import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Rooms.css';

import roomCh3 from '../assets/imgs/rooms-ch3.png';

class Chapter3 extends Component {
    render() {
        return (
            <div className="Rooms" ref={(div) => (this.appContainer = div)}>
                <Header />
                <div className="Rooms-container">
                    <div className="Room-top"></div>
                    <div className="Room-mid">
                        <div className="Room-title">THE GATEKEEPER</div>
                        <div className="Room-img">
                            <img src={roomCh3} alt="" />
                        </div>
                        <div className="Room-description">
                            <div className="text">
                                Chapter 3 continues where Chapter 2 left off. You survived the
                                vandal attack on The Bunker and collected survival gear from The
                                Hive. Now you must travel through an underground tunnel to make it
                                to the UHC. You stumble upon a locked gate and suddenly find
                                yourself trapped by The Gatekeeper, a creature like human, who has
                                been handsomely paid by Lightcrawler to trap victims, and unless you
                                can fix his broken generator, he will alert the vandals. Will you
                                and your team get the generator working before time runs out and can
                                The Gatekeeper be trusted?
                                <p>This game involves a live actor.</p>
                            </div>
                            <div className="table-container">
                                <div className="table-row">
                                    <div className="table-label">MISSION</div>
                                    <div className="table-text">
                                        Fix a generator for The Gatekeeper as a bargain so you can
                                        be set free.
                                    </div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">TIME</div>
                                    <div className="table-text">50 min</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">PLAYERS</div>
                                    <div className="table-text">Min 2, Max 8</div>
                                </div>
                                <div className="table-row">
                                    <div className="table-label">DIFFICULTY</div>
                                    <div className="table-text">
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star checked"></span>
                                        <span className="fa fa-star"></span>
                                    </div>
                                </div>
                            </div>
                            <div className="note">
                                * If you desire to book a specific game that is not reflected on our
                                Ticket Schedule please contact us for further availability. <br />*
                                You can swap Chapters. If for a desired time slot you would prefer
                                to do another Chapter
                                <br /> that is originally offered on our Ticketing Site, please
                                contact us to swap for your preferred Chapter.
                            </div>
                        </div>
                    </div>
                    <div className="Room-bottom"></div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default Chapter3;
